import { height } from "@fortawesome/free-solid-svg-icons/fa0";
import React,{useState, useEffect} from "react";
import LoadingSpinner from "../component/LoadingSpinner";
import { useNavigate } from "react-router-dom";
const OverviewPage = () =>{
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const handleLoad = () => setLoading(false);
    const handleError = () => setLoading(false); 
 
    useEffect(() => {
        // Check session storage for "code"
        const sessioncode = sessionStorage.getItem("sessioncode");
        //console.log(sessioncode);
        if (sessioncode === " ") {
            navigate('/');
        } 
      }, []);
    
    return(<>
    
    {loading && <LoadingSpinner/>}

    <iframe src="https://wns-sentry.sony.eu/TnE-Sentry-Report/" style={{minHeight:"98.5vh", width:"99.5vw"}}
    onLoad={handleLoad}
    onError={handleError}
     />
    
    </>)
}
export default OverviewPage